export function makePieFilter(elem) {
  const svgns = 'http://www.w3.org/2000/svg';
  const filter = document.createElementNS(svgns, 'filter');
  filter.setAttribute('id', 'f2');
  filter.setAttribute('x', 0);
  filter.setAttribute('y', 0);
  filter.setAttribute('width', '200%');
  filter.setAttribute('height', '200%');

  const offset = document.createElementNS(svgns, 'feOffset');
  offset.setAttribute('result', 'offOut');
  offset.setAttribute('in', 'SourceGraphic');
  offset.setAttribute('dx', 20);
  offset.setAttribute('dy', 20);

  const blur = document.createElementNS(svgns, 'feGaussianBlur');
  blur.setAttribute('result', 'blurOut');
  blur.setAttribute('in', 'offOut');
  blur.setAttribute('stdDeviation', 10);

  const blend = document.createElementNS(svgns, 'feBlend');
  blend.setAttribute('in', 'SourceGraphic');
  blend.setAttribute('in2', 'blurOut');
  blend.setAttribute('mode', 'normal');

  filter.appendChild(offset);
  filter.appendChild(blur);
  filter.appendChild(blend);

  if (elem) {
    elem.appendChild(filter);
  }
}

export function makeSVGShape(elem, options) {
  let newElem = null;
  const svgns = 'http://www.w3.org/2000/svg';
  const bounds = elem.getBBox();

  switch (options.type) {
    case 'bg': {
      const style = getComputedStyle(elem);
      const padding_top = parseInt(style['padding-top'], 10);
      const padding_left = parseInt(style['padding-left'], 10);
      const padding_right = parseInt(style['padding-right'], 10);
      const padding_bottom = parseInt(style['padding-bottom'], 10);

      newElem = document.createElementNS(svgns, 'rect');
      newElem.setAttribute('x', bounds.x - (padding_left || 8));
      newElem.setAttribute('y', bounds.y - (padding_top || 4));
      newElem.setAttribute('width', bounds.width + (padding_left || 8) + (padding_right || 8));
      newElem.setAttribute('height', bounds.height + (padding_top || 4) + (padding_bottom || 4));
      newElem.setAttribute('fill', '#edf0f9');
      newElem.setAttribute('rx', 8);

      if (elem.hasAttribute('transform'))
        newElem.setAttribute('transform', elem.getAttribute('transform'));
      break;
    }
    case 'circle-shadow': {
      newElem = document.createElementNS(svgns, 'circle');
      newElem.setAttribute('r', bounds.x);
      newElem.setAttribute('cx', bounds.width - 10);
      newElem.setAttribute('cy', bounds.height - 10);
      newElem.setAttribute('fill', 'rgba(49, 70, 147, 0.16)');
      newElem.setAttribute('filter', `url(#${options.filterId})`);
      break;
    }
    default:
      break;
  }

  if (newElem) elem.parentNode.insertBefore(newElem, elem);
}

export function updateMonthlyRequestsPieChartLayout(node) {
  const children = Array.from(node.children);
  if (children.length) {
    const [g1, g2] = children;
    if (g1) {
      const [cr] = Array.from(g1.children);
      if (cr && cr.id) {
        const crN = document.querySelector(`#${cr.id}`);
        if (crN) {
          crN.setAttribute('r', '60');
          crN.setAttribute('fill', 'white');
          makeSVGShape(crN, { type: 'circle-shadow', filterId: 'f2' });
        }
      }
    }
    if (g2) {
      const [t1, t2] = Array.from(g2.children);
      if (t1 && t1.id) {
        const t1N = document.querySelector(`#${t1.id}`);
        if (t1N) {
          t1N.setAttribute('y', 136);
          makeSVGShape(t1N, { type: 'bg' });
        }
      }
      if (t2) {
        const t2N = document.querySelector(`#${t2.id}`);
        if (t2N) t2N.setAttribute('y', 109);
      }
    }
  }
}

/**
 * Move the embed SVG to the DOM as plain
 * @param {String} name
 */
export function replaceEmbedSVG(name) {
  try {
    const nodes = Array.from(document.querySelectorAll(`#${name}-svg-image`));
    if (nodes.length > 0) {
      _.each(nodes, (ob) => {
        ob.parentNode.replaceChild(ob.contentDocument.documentElement, ob);
      });
    }
  } catch (e) {}
  return null;
}
